import { ReactNode } from "react"
import styled from "styled-components"

const FixCtaBox = styled.div`
  display: flex;
  padding: var(--spacing_m, 12px) var(--spacing_xl, 24px)
    var(--spacing_xl, 24px) var(--spacing_xl, 24px);
  padding-bottom: 16px;
  align-items: center;
  align-self: stretch;
  position: relative;

  position: fixed;
  width: 100%;
  z-index: 100;
  bottom: 0;
  max-width: var(--app-max-width);

  .blur-filter {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    pointer-events: none;
  }

  .blur-filter:nth-child(1) {
    backdrop-filter: blur(1px);
    -webkit-backdrop-filter: blur(1px);
    mask: linear-gradient(
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 1) 10%,
      rgba(0, 0, 0, 1) 30%,
      rgba(0, 0, 0, 0) 40%
    );
    -webkit-mask: linear-gradient(
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 1) 10%,
      rgba(0, 0, 0, 1) 30%,
      rgba(0, 0, 0, 0) 40%
    );
  }

  .blur-filter:nth-child(2) {
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
    mask: linear-gradient(
      rgba(0, 0, 0, 0) 10%,
      rgba(0, 0, 0, 1) 20%,
      rgba(0, 0, 0, 1) 40%,
      rgba(0, 0, 0, 0) 50%
    );
    -webkit-mask: linear-gradient(
      rgba(0, 0, 0, 0) 10%,
      rgba(0, 0, 0, 1) 20%,
      rgba(0, 0, 0, 1) 40%,
      rgba(0, 0, 0, 0) 50%
    );
  }

  .blur-filter:nth-child(3) {
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    mask: linear-gradient(
      rgba(0, 0, 0, 0) 15%,
      rgba(0, 0, 0, 1) 30%,
      rgba(0, 0, 0, 1) 50%,
      rgba(0, 0, 0, 0) 60%
    );
    -webkit-mask: linear-gradient(
      rgba(0, 0, 0, 0) 15%,
      rgba(0, 0, 0, 1) 30%,
      rgba(0, 0, 0, 1) 50%,
      rgba(0, 0, 0, 0) 60%
    );
  }

  .blur-filter:nth-child(4) {
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    mask: linear-gradient(
      rgba(0, 0, 0, 0) 20%,
      rgba(0, 0, 0, 1) 40%,
      rgba(0, 0, 0, 1) 60%,
      rgba(0, 0, 0, 0) 70%
    );
    -webkit-mask: linear-gradient(
      rgba(0, 0, 0, 0) 20%,
      rgba(0, 0, 0, 1) 40%,
      rgba(0, 0, 0, 1) 60%,
      rgba(0, 0, 0, 0) 70%
    );
  }

  .blur-filter:nth-child(5) {
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    mask: linear-gradient(
      rgba(0, 0, 0, 0) 40%,
      rgba(0, 0, 0, 1) 60%,
      rgba(0, 0, 0, 1) 80%,
      rgba(0, 0, 0, 0) 90%
    );
    -webkit-mask: linear-gradient(
      rgba(0, 0, 0, 0) 40%,
      rgba(0, 0, 0, 1) 60%,
      rgba(0, 0, 0, 1) 80%,
      rgba(0, 0, 0, 0) 90%
    );
  }

  .blur-filter:nth-child(6) {
    backdrop-filter: blur(32px);
    -webkit-backdrop-filter: blur(32px);
    mask: linear-gradient(rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 1) 80%);
    -webkit-mask: linear-gradient(rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 1) 80%);
  }

  .blur-filter:nth-child(7) {
    backdrop-filter: blur(64px);
    -webkit-backdrop-filter: blur(64px);
    mask: linear-gradient(rgba(0, 0, 0, 0) 70%, rgba(0, 0, 0, 1) 100%);
    -webkit-mask: linear-gradient(rgba(0, 0, 0, 0) 70%, rgba(0, 0, 0, 1) 100%);
  }

  .gradient {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    pointer-events: none;
    background: linear-gradient(
      180deg,
      rgba(0, 38, 58, 0) 0%,
      rgba(0, 38, 58, 0.8) 90%,
      #00263a 100%
    );
  }
`

export default ({
  children,
  style = {},
}: {
  children: ReactNode
  style?: React.CSSProperties
}) => {
  return (
    <FixCtaBox style={style}>
      <div className="blur-filter" />
      <div className="blur-filter" />
      <div className="blur-filter" />
      <div className="blur-filter" />
      <div className="blur-filter" />
      <div className="blur-filter" />
      <div className="blur-filter" />
      <div className="gradient" />
      {children}
    </FixCtaBox>
  )
}
